"use client";

import { ArrowUpRight, Blocks, BrainCircuit, Lock } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
export default function DocumentsSection() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const pillars = [{
    number: "01",
    title: "PEDOMAN SIBER",
    icon: Blocks,
    description: "Kami menjunjung tinggi integritas jurnalistik melalui kepatuhan ketat terhadap Pedoman Pemberitaan Media Siber. Setiap konten yang kami tayangkan melewati proses verifikasi berlapis untuk memastikan akurasi, keberimbangan, dan tanggung jawab publik yang mutlak."
  }, {
    number: "02",
    title: "HAK JAWAB & KOREKSI",
    icon: BrainCircuit,
    description: "Transparansi adalah fondasi kepercayaan pembaca. Kami menyediakan ruang seluas-luasnya bagi hak jawab dan koreksi sesuai UU Pers. Komitmen kami adalah menyajikan kebenaran yang dinamis, memberikan ruang bagi klarifikasi demi keadilan informasi."
  }, {
    number: "03",
    title: "KEBIJAKAN PRIVASI",
    icon: Lock,
    description: "Keamanan data pembaca dan narasumber adalah prioritas utama. Kami menerapkan protokol perlindungan data tingkat tinggi untuk menjamin kerahasiaan informasi pribadi, memastikan interaksi Anda dengan platform kami tetap aman, privat, dan terlindungi."
  }];
  return <section data-section-id="5200" id="documents-section" className="bg-background text-foreground py-32 md:py-50 px-6 md:px-12 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        {}
        <div ref={headerRef} className={`grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 mb-16 md:mb-24 transition-all duration-700 ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="lg:col-span-4">
            <div className="flex flex-col gap-3">
              <span className="font-mono text-xs md:text-sm tracking-widest uppercase text-primary">
                02 / LEGALITAS & STANDAR
              </span>
              <div className="h-px w-16 bg-primary" />
            </div>
          </div>
          <div className="lg:col-span-8">
            <h2 className="font-default font-black text-4xl sm:text-5xl md:text-6xl lg:text-[88px] leading-[0.95] tracking-tight uppercase">
              TIGA /
              <br />
              PILAR REDAKSI.
            </h2>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {pillars.map((pillar, i) => {
          const Icon = pillar.icon;
          return <PillarCard key={i} pillar={pillar} Icon={Icon} index={i} />;
        })}
        </div>
      </div>
    </section>;
}
function PillarCard({
  pillar,
  Icon,
  index
}: {
  pillar: {
    number: string;
    title: string;
    description: string;
  };
  Icon: React.ComponentType<{
    className?: string;
    strokeWidth?: number;
  }>;
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <div ref={ref} data-index={index} style={{
    transitionDelay: `${index * 100}ms`
  }} className={`transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
      <Card className="group relative h-full min-h-[480px] bg-card backdrop-blur-xl border border-border rounded-md p-10 md:p-12 flex flex-col shadow-md hover:border-primary hover:shadow-xl transition-all duration-500">
        {}
        <div className="font-mono text-5xl md:text-6xl font-light text-primary transition-transform duration-500 group-hover:scale-110 origin-left">
          {pillar.number}
        </div>

        {}
        <div className="h-px w-full bg-primary/20 mt-6 mb-10 group-hover:bg-primary transition-colors duration-500" />

        {}
        <Icon className="size-8 text-muted-foreground group-hover:text-primary transition-colors duration-500 mb-8" strokeWidth={1} />

        {}
        <h3 className="font-default font-bold text-2xl md:text-3xl uppercase tracking-tight mb-6 leading-tight text-foreground">
          {pillar.title}
        </h3>

        {}
        <p className="font-default text-base md:text-[17px] leading-relaxed text-muted-foreground mb-10 flex-grow">
          {pillar.description}
        </p>

        {}
        <div className="mt-auto">
          <Button variant="ghost" size="sm" className="font-mono text-xs tracking-widest uppercase text-foreground hover:text-primary hover:bg-transparent p-0 h-auto group/btn">
            DETAIL PROTOKOL
            <ArrowUpRight className="size-4 text-primary transition-transform duration-300 group-hover/btn:translate-x-1 group-hover/btn:-translate-y-1" />
          </Button>
        </div>
      </Card>
    </div>;
}